/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { INewContactCreation } from './../modules/szf-contact-us/szf-contact-us.view';
/**
 * PostNewContact Input Action
 */
export class PostNewContactInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public token: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone: string;
    public countryCode: string;
    public updateNpromotion: boolean;
    constructor(token:string,data:INewContactCreation) {
        this.token= token;
        this.email= data.email;
        this.firstName= data.firstName;
        this.lastName= data.lastName;
        this.phone= data.phone;
        this.countryCode= data.countryCode;
        this.updateNpromotion= data.updateNpromotion;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SZFCREATECONTACT`;
    public getCacheObjectType = () => 'SZFCREATECONTACT';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IPostNewContactData {
    status: boolean;
    msg:string | undefined;
    id: string | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createNewContactInput = (args: Msdyn365.ICreateActionContext,token:string, inputData:INewContactCreation): Msdyn365.IActionInput => {
    return new PostNewContactInput(token, inputData);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function createNewContactDataAction(input: PostNewContactInput, ctx: Msdyn365.IActionContext): Promise<IPostNewContactData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    const token = input.token;
    const szfCRMDomain = ctx.requestContext.app.config.szfCRMDomain;
    const data = {
        "firstname": input.firstName,
        "lastname": input.lastName,
        "emailaddress1": input.email,
        "szf_mblregion": input.countryCode,
        "szf_mbllocalnumber": input.phone,
        "donotsendmm": !input.updateNpromotion
    };
    const response = await Msdyn365.sendRequest<any>(`${szfCRMDomain}/api/data/v9.2//contacts`, "post", data, {
        headers: {
            'Prefer': 'return=representation',
            'MSCRM.SuppressDuplicateDetection': 'false',
            'Authorization':`Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    if(response && response.data && response.data.contactid){
        return {
            status: true,
            msg: 'success',
            id: response.data.contactid
        };
    }else if (response && response.data && response.data.error){
        return {
            status: false,
            msg: response.data.error.message,
            id: undefined
        };
    }else{
        return {
            status: false,
            msg: undefined,
            id: undefined
        };
    }
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPostNewContactData[]>('/get/example/id/1', 'get');
    // return { text: 'Static data from action' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostNewContactData>>createNewContactDataAction,
    // TODO: Give your data action a unique id
    id: 'PostNewContact',
    input: createNewContactInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
